// Premium API — mirrors /app/mobile/src/lib/premium-api.ts
import { apiFetch } from './api';

export const TIER_LABEL = {
  FREE: 'Free',
  PREMIUM_LITE: 'Premium Lite',
  PREMIUM: 'Premium',
  PREMIUM_PLUS: 'Premium Plus',
};

export const TIER_TAGLINE = {
  FREE: 'Everything you need to collect memories.',
  PREMIUM_LITE: 'Publish an unwatermarked lookbook.',
  PREMIUM: 'Longer videos, bigger files, unwatermarked lookbook.',
  PREMIUM_PLUS: 'Priority frame exports for the sharpest turnaround.',
};

export const fetchPricing = (eventId) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/premium/pricing`);

export const createCheckout = (eventId, originUrl) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/premium/checkout`, {
    method: 'POST',
    body: JSON.stringify({ origin_url: originUrl || '' }),
  });

export const verifyCheckout = (eventId, sessionId) =>
  apiFetch(
    `/api/v1/events/${encodeURIComponent(eventId)}/premium/verify?session_id=${encodeURIComponent(sessionId)}`,
  );

export const fetchPaymentHistory = (eventId) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/premium/payments`);

export function formatCents(cents, currency = 'usd') {
  const amount = (cents / 100).toFixed(2);
  const symbol = currency.toLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `;
  return `${symbol}${amount}`;
}
